import $ from 'jquery';

const float = () => {
  const $float = $('.js-float');
  if (!$float.length) return;

  let isHidden = true;
  const THRESHOLD = 0; // 0 = 完全に最上部

  // 初期状態
  if (window.scrollY > THRESHOLD) {
    isHidden = false;
    $float.show();
  } else {
    $float.hide();
  }

  const onScroll = () => {
    const y = window.scrollY || window.pageYOffset;

    if (y <= THRESHOLD && !isHidden) {
      isHidden = true;
      $float.stop(true, true).fadeOut(200);
    } else if (y > THRESHOLD && isHidden) {
      isHidden = false;
      $float.stop(true, true).fadeIn(200);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  // クリーンアップ
  return () => {
    window.removeEventListener('scroll', onScroll);
  };
};

const toggleFloatOnFooter = () => {
  const targets = [
    document.querySelector('#js-drawerMenuToggle'),
    document.querySelector('.js-headerAccordionButton'),
  ].filter(Boolean);
  const footerElm = document.querySelector('.js-footerPosition');
  if (!targets.length || !footerElm) return;

  const states = targets.map(() => ({ isHidden: false }));

  const onScroll = () => {
    if (window.innerWidth >= 768) return;

    const footerRect = footerElm.getBoundingClientRect();

    targets.forEach((elm, i) => {
      const rect = elm.getBoundingClientRect();
      const isOverlapping = rect.bottom > footerRect.top && rect.top < footerRect.bottom;

      if (isOverlapping && !states[i].isHidden) {
        states[i].isHidden = true;
        $(elm).stop(true, true).fadeOut();
      } else if (!isOverlapping && states[i].isHidden) {
        states[i].isHidden = false;
        $(elm).stop(true, true).fadeIn();
      }
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
};

export { float as default, toggleFloatOnFooter };
